import type { SVGProps } from "react";

/**
 * The brand carrot — drawn (not the lucide glyph) so it carries the
 * homestead-meets-AI personality across the wordmark and hero motif.
 */
export function Carrot({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 78" fill="none" className={className} aria-hidden="true" {...props}>
      <g>
        {/* leaves */}
        <g fill="var(--field)">
          <path d="M32 24C29 9 22 3 14 1c4 9 8 16 16 23z" />
          <path d="M32 24C32 6 32 0 32 -3c5 7 6 17 4 27z" />
          <path d="M32 24C35 9 42 3 50 1c-4 9-8 16-16 23z" />
        </g>
        {/* body */}
        <path
          fill="var(--carrot)"
          d="M32 24 51 30C48 50 41 70 32 78 23 70 16 50 13 30Z"
        />
        {/* shade */}
        <path fill="var(--carrot-deep)" opacity="0.35" d="M32 24 51 30C48 50 41 70 32 78V24Z" />
        {/* ridges */}
        <g stroke="var(--carrot-deep)" strokeWidth="2" strokeLinecap="round" opacity="0.6">
          <path d="M24 38 32 41" />
          <path d="M27 52 35 54" />
          <path d="M25 65 31 66" />
        </g>
      </g>
    </svg>
  );
}
